export function stripTrailingSlash(str: string) {
  if (str.substring(str.length, str.length - 1) === '/')
    return str.substring(0, str.length - 1)

  return str
}

export function formatItems(items: Array<any>) {
  return items.map((e) => {
    return {
      ...e,
      content: {
        ...e.content,
        interest: e.content.interest.replace(',', '.'),
      },
    }
  })
}
